<script lang="ts">
  import { TRACK_POINTS, type DisplayView, type PublicPlayer } from '@banger/shared';
  import { celebrationWord, winGot } from '../lib/trackCopy';
  import BangerFlash from '../shared/BangerFlash.svelte';

  let { view, byId, steals = [] }: {
    view: DisplayView; byId: Map<string, PublicPlayer>;
    /** This round's steal lines (the events still hold them in the banger phase). */
    steals?: string[];
  } = $props();

  // Album: everyone who finished the track on this song shares the celebration.
  const winners = $derived(view.winners.flatMap((id) => byId.get(id) ?? []));
  const [first, ...others] = $derived(winners);
  const track = $derived(view.mode === 'album' ? view.track : null);
  const got = $derived(winGot(view));
  const headline = $derived(
    track ? `+${TRACK_POINTS[track]} pts · Track ${track} of 3${track === 3 ? ' · Final results next!' : ''}` : 'Final results next!',
  );
</script>

<BangerFlash
  emoji={first?.emoji ?? '🎉'}
  name={first?.name ?? 'Someone'}
  {others}
  word={celebrationWord(track)}
  {got}
  caption={[headline, ...steals].join('\n')}
/>
